var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BdGraphNode } from '../../../lib/graph/graph.model';
// Model for node available in state for user interaction with scene graph
var ViewTreeNode = /** @class */ (function (_super) {
    __extends(ViewTreeNode, _super);
    function ViewTreeNode(data) {
        var _this = _super.call(this, data.id) || this;
        _this.label = data.label || '';
        _this.boolState.pickable = data.hasOwnProperty('pickable') ? data.pickable : true;
        _this.boolState.renderable = data.renderable || false;
        _this.boolState.shown = data.shown || false;
        _this.boolState.expanded = data.expanded || false;
        return _this;
    }
    return ViewTreeNode;
}(BdGraphNode));
export { ViewTreeNode };
